import { useMutation, useQueryClient } from "react-query";
import { updateSalesLead } from "../../../../../actions/Utilities/SalesLead";
import { toast } from "../../../../../components/toastNotification";
import { SalesLeadData } from "../types/SalesLeadInterface";

export default function useUpdateSalesLead() {
  const queryClient = useQueryClient();

  const { mutate } = useMutation(
    (NewData: SalesLeadData) => updateSalesLead(NewData),
    {
      onSuccess: (res: any) => {
        if (res.data === "Duplicate") {
          toast.fire("Saving Failed", "The data already exists!", "error");
        } else {
          queryClient.invalidateQueries(["SalesLead"]);
          toast.fire("Success", "Sales Lead Updated Successfully", "success");
        }
      },
      onError: (error) => {
        toast.fire("Saving Failed", "Failed to Update Sales Lead!", "error");
      },
    }
  );
  return mutate;
}
